export const environment = {
  production: true,
  OnetrustCookieConsentKey: '29145a4b-89f5-45ce-ab99-7980e3df4ff5',
  helpUrl: 'https://help.mysedgwick.com/mySedgwick5/Help.htm',
};
